import type { Service } from '../redux/types.ts';

const dbName = 'TopServices';

type UserUsage = Record<string, { title: string; count: number }>;
type DB = Record<string, UserUsage>;

export const trackUserUsage = (userId: string, service: Service) => {
  const data = localStorage.getItem(dbName) || '{}';

  let db = {} as DB;
  try {
    db = JSON.parse(data);
  } catch (e) {
    localStorage.setItem(dbName, '{}');
  }

  const user = db[userId] || {};
  const module = user[service.path] || {};

  module.count = module.count ? module.count + 1 : 1;
  module.title = service.title;

  user[service.path] = module;
  db[userId] = user;

  localStorage.setItem(dbName, JSON.stringify(db));
};

export const getTopServicesForUser = (userId: string, numOfServices: number): { path: string; title: string }[] => {
  const data = localStorage.getItem(dbName) || '{}';

  let db = {} as DB;
  try {
    db = JSON.parse(data);
  } catch (e) {
    localStorage.setItem(dbName, '{}');
  }

  const user = db[userId] || {};
  const modules = Object.entries<{ title: string; count: number }>(user).map(([path, module]) => ({ path, ...module }));

  const res = modules.sort((a, b) => b.count - a.count).slice(0, numOfServices);

  return res.map(module => ({ path: module.path, title: module.title }));
};
